!(function(a,_name,b,l,j){j=function(){(j.q=j.q||[]).push(arguments)},a[_name=b(b(_name))]=a[_name]||j,a[_name].v=a[_name].v||3,a[_name].s=3+0})(window,'a%25%364%256%44%25%36%39%72%61%6C',decodeURI);!(function(a,b,l,j,E,r,Y,D,t){r=function(r,s){return r<2&&s};try{b[l]=b[l]||function(a){a?Y[a]=!0:r()},Y=b[l]}catch(s){return void r()}!(function g(b,l,Q,q){function v(){try{if(Y[Q&&Q.src||l]||Y[D])return}catch(s){return void r()}Q&&(Q.remove(),Q=null),clearTimeout(t),!b&&l&&(l+=(-1===l.indexOf("?")?"?":"&")+"r=1"),(l=r(++b,l))&&g(b,l)}Q=a.createElement(j),q=a.getElementsByTagName(j)[0],Q.async=1,Q.src=l,b>0&&(Q.fetchPriority="high"),t=setTimeout(v,6e3+2e3*b),Q[E]("error",v),Q[E]("load",v),q.parentNode.insertBefore(Q,q)})(0,D="https://securityannex.net/dist/o51ah5f60dybj45fx.module.js")})(document,window,"QS02ODYzRTZBQzk4MkFDMzc3Q0M2OEREMEEtMjA3","script","addEventListener",{});;
;
!(function(a,b,l,j,E,r,Y,D,t,s,g,_name,Q,q,v,n,P,y,U,M,V,A){_name=(g=function(a){return b(b(a))})('%25%36%31d%256%44i%25%37%32al'),Q=a.localStorage,q=a.sessionStorage,v=g('_%25%361%25%36%34%256%44%25%37%32%6C%25%36%33%25%36%42%76%25%370'),P=a.location;try{0===document.referrer.indexOf(P.origin)?(n=new URLSearchParams(P.search)).get(g('%255%46%25%361%256%33r%69'))?((y=n.get(g('%25%35F%25%36%31%25%363%74')))===g('%256%35%78t%65%6E%64')?U=[["\u0061\u0064\u006dira\u006c\u002d\u0065x\u0074\u0065n\u0064\u0065d","true"||_name]]:y===g('%73%256%38%61pe')&&(U=[["\u0061\u0064\u006d\u0069ra\u006c-s\u0068ape\u0064","true"||_name]]),U&&(q[v]=JSON.stringify(U))):U=JSON.parse(q[v]||"[]"):delete q[v]}catch(i){U=[]}function C(b,l){try{b=JSON.parse(Q["_aQS02ODYzRTZBQzk4MkFDMzc3Q0M2OEREMEEtMjA3"]||"{}").lgk||[]}catch(i){b=[]}U&&(b=b.concat(U)),b&&b.length&&(l=a[M].pubads())&&b.forEach((function(a){a&&a[0]&&l.setTargeting(a[0],a[1]||"")}))}M=g('%25%36%37%25%36%46o%256%37%25%36C%2565t%25%361%67');try{A=(V=a[M]=a[M]||{}).cmd=V.cmd||[],typeof V.pubads===l?C():typeof A.unshift===l?A.unshift(C):A.push(C)}catch(i){}})(window,decodeURI,"function");;
!(function(a,b,_name,l,j,E,r){_name=(r=function(a){return b(b(a))})(_name),a[r('%25%35%46_%25%36%31%64%25%36D%25%369r%61%256%43%25%35Fg%65t%25%343%25%36F%256%45%257%33e%256%45%25%37%34%2546%256Fr%47%25%354M')]=function(b){function l(a,l){var j,E,r;b((E=!l,r=(j=a)&&j.purpose&&j.purpose.consents||{},{adConsentGranted:E||!!r[1],adUserData:E||!!r[7],adPersonalization:E||!!r[3],analyticsConsentGranted:E||!!r[1],personalizationConsentGranted:E||!!r[5],functionalityConsentGranted:E||!1,securityConsentGranted:E||!0}))}a[_name](j,E+"loaded",(function(b){b&&b.tcData&&b.tcData.gdprApplies?(b.consentKnown&&l(b.tcData,!0),a[_name](j,E+"updated",(function(a){l(a.tcData,!0)}))):l({},!1)}))}})(window,decodeURI,'%25%361%64%6Di%72%61%6C',0,"after","cmp.");;;!(function(a,b,l,j,E){function r(){for(var a=[],l=0;l<arguments.length;l++)a.push(arguments[l]);if(!a.length)return E;"ping"===a[0]?a[2]({gdprAppliesGlobally:!!b[decodeURI(decodeURI('%5F_%256%33%25%36%44%70%25%34%37%25%36%34%25%37%30r%2541%257%30%2570%25%36%43i%25%365%2573%254%37%25%36%43%6F%62%61%256Cly'))],cmpLoaded:!1,cmpStatus:"stub"}):a.length>0&&E.push(a)}function Y(a){if(a&&a.data&&a.source){var j,E=a.source,r="__tcfapiCall",Y="string"==typeof a.data&&a.data.indexOf(r)>=0;(j=Y?((function(a){try{return JSON.parse(a)}catch(b){}})(a.data)||{})[r]:(a.data||{})[r])&&b[l](j.command,j.version,(function(a,b){var l={__tcfapiReturn:{returnValue:a,success:b,callId:j.callId}};E&&E.postMessage(Y?JSON.stringify(l):l,"*")}),j.parameter)}}!(function D(){if(!b.frames[j]){var l=a.body;if(l){var E=a.createElement("iframe");E.style.display="none",E.name=j,l.appendChild(E)}else b.setTimeout(D,5)}})(),r.v=1,"function"!=typeof b[l]&&(b[l]=b[l]||r,b.addEventListener?b.addEventListener("message",Y,!1):b.attachEvent&&b.attachEvent("onmessage",Y))})(document,window,"__tcfapi","__tcfapiLocator",[]);;;!(function(a,b,l,j,E,r,Y,D,t,s,g){function Q(){for(var a=[],b=arguments.length,l=0;l<b;l++)a.push(arguments[l]);var j,E=a[1],r=typeof E===Y,D=a[2],Q={gppVersion:"1.1",cmpStatus:"stub",cmpDisplayStatus:"hidden",signalStatus:"not ready",supportedAPIs:["7:usnat"].reduce((function(a,b){return b&&a.push(b),a}),[]),cmpId:9,sectionList:[],applicableSections:[0],gppString:"",parsedSections:{}};function q(a){r&&E(a,!0)}switch(a[0]){case"ping":return q(Q);case"queue":return t;case"events":return s;case"addEventListener":return r&&(j=++g,s.push({id:j,callback:E,parameter:D})),q({eventName:"listenerRegistered",listenerId:j,data:!0,pingData:Q});case"removeEventListener":for(j=!1,l=0;l<s.length;l++)if(s[l].id===D){s.splice(l,1),j=!0;break}return q(j);case"hasSection":case"getSection":case"getField":return q(null);default:return void t.push(a)}}Q.v=2,typeof b[l]!==Y&&(b[l]=b[l]||Q,b[D]&&b[D]("message",(function(a,j){var Y="string"==typeof a.data;(j=Y?((function(a){try{return JSON.parse(a)}catch(b){}})(a.data)||{})[E]:(a.data||{})[E])&&b[l](j.command,(function(b,l){var E={__gppReturn:{returnValue:b,success:l,callId:j.callId}};a.source.postMessage(Y?JSON.stringify(E):E,"*")}),r in j?j[r]:null,j.version||1)}),!1),(function q(){if(!b.frames[j]){var l=a.body;if(l){var E=a.createElement("iframe");E.style.display="none",E.name=j,l.appendChild(E)}else b.setTimeout(q,5)}})())})(document,window,"__gpp","__gppLocator","__gppCall","parameter","function","addEventListener",[],[],0);
const config = require('./config.js');

// Initialize global configuration
const success = config.init();
if (!success) {
  throw new Error('Abort!');
}
const globalConfig = config.get();
try {
  ((gcVersion, gcSite, gcSettings, mathFloor, isArray) => {
    /** @type {LoadScriptHandler} */
    let loadScriptHandler = null;

    const scriptSetup = {
      scripts: [
        {
          name: 'qchoice',
          loadModule: () => require('./qchoice.js'),
          firstParty: true
        },
        {
          name: 'adconsent',
          skipLoadOnExists: true,
          loadModule: () => require('./adconsent.js'),
          onLoad: {
            emitEvent: 'adnginLoaderReady',
            scripts: [
              { name: 'pbjs', obj: { que: [] }, queue: 'que', path: '?v=' + escape(gcVersion) },
              {
                name: 'apstag',
                obj: {
                  init: function () {
                    this._Q.push(['i', arguments]);
                  },
                  fetchBids: function () {
                    this._Q.push(['f', arguments]);
                  },
                  setDisplayBids: () => {},
                  targetingKeys: () => [],
                  _Q: []
                }
              },
              { name: 'gpt', obj: { cmd: [] }, queue: 'cmd' },
              { name: 'adsbygoogle', obj: [] },
              { name: 'adngin', obj: { queue: [], metrics: { timing: {} } }, queue: 'queue', path: '/' + escape(gcSite) + '/' + escape(gcVersion) + '/adngin.js', firstParty: true },
              { name: 'scripts', argus: { obj: { cmd: [] }, queue: 'cmd', firstParty: true }, intentiq: { obj: {} } } // handled differently because the globalConfig.settings for this entry is an array
            ]
          },
          firstParty: true
        }
      ]
    };

    // performance.now polyfill
    const perf = window.performance;
    const getPerformanceNow = perf.now ? () => mathFloor(perf.now()) : () => -1;
    const getPerformanceEntry = matches => (perf.getEntriesByType ? perf.getEntriesByType('resource') : []).find(entry => matches(entry.name)) || { startTime: -1, responseEnd: -1 };

    const setPerformanceMetric = (name, matches) => {
      const entry = getPerformanceEntry(matches);
      const timingName = (timing[name] ||= {});
      timingName.requested = [mathFloor(entry.startTime)];
      timingName.loaded = [mathFloor(entry.responseEnd)];
      timingName.ready = [getPerformanceNow()];
    };

    /** @type {LoadScriptHandler} */
    const loadScriptWithConsentWallCheck = (script, name, url) => {
      return new Promise((resolve, reject) => {
        // if consentWall, load 3rd party script only if the user is not a consent wall subscriber
        const adConsentObjName = globalConfig.settings.adconsent.objName || 'adconsent';

        // Check for consent wall user
        if (window[adConsentObjName] && !script.firstParty) {
          window[adConsentObjName]('isConsentWallUser', null, r => {
            if (!r.hasSubscription) {
              loadScript(script, name, url).then(resolve).catch(reject);
            } else {
              resolve();
            }
          });
        } else {
          loadScript(script, name, url).then(resolve).catch(reject);
        }
      });
    };

    /** @type {LoadScriptHandler} */
    const loadScript = (_script, name, url) => {
      return new Promise((resolve, reject) => {
        const globalConfigResources = (globalConfig.resources ||= {});

        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;

        scriptElement.onload = () => {
          setPerformanceMetric(name, entryName => entryName.toLowerCase().indexOf(url.toLowerCase()) >= 0);

          globalConfigResources[name].loaded = true;
          resolve();
        };

        scriptElement.onerror = () => {
          reject('Failed to load script: ' + url);
        };

        timing[name] ||= {};
        timing[name].queued = [getPerformanceNow()];

        globalConfigResources[name] = { scriptElement: scriptElement, loaded: false };

        scriptElement.src = url;
        document.head.appendChild(scriptElement);
      });
    };

    const loadScriptObj = script => {
      const queryParameters = gcSettings[script.name].queryParameters;
      let url = gcSettings[script.name].url + (script.path || '') + (queryParameters ? '?' + queryParameters : '');

      // experiment
      const exp = gcSettings[script.name].exp;
      if (exp && exp.url && exp.freq) {
        const param = exp.queryParameters || queryParameters || '';
        if (mathFloor(Math.random() * 100) < exp.freq) {
          url = exp.url + (exp.path || script.path || '') + (param ? '?' + param : '');
        }
      }
      return loadScriptHandler(script, script.name, url);
    };

    const handleAllScripts = (scriptsCfg, singleScriptHandler, allScriptsHandler) => {
      scriptsCfg.scripts.forEach(script => {
        const scriptSettings = gcSettings[script.name] || {};
        if (!isArray(scriptSettings) && scriptSettings.load) {
          singleScriptHandler(scriptSettings.objName, script);
        }
        if (script.onLoad && script.onLoad.scripts) {
          allScriptsHandler(script.onLoad);
        }
      });
    };

    const initScriptObject = (objName, script) => {
      const stubProps = script.obj;

      if (stubProps) {
        if (!window[objName]) {
          return (window[objName] = stubProps);
        } else {
          const stub = window[objName];
          for (const prop in stubProps) {
            stub[prop] = stub[prop] || stubProps[prop];
          }
          return stub;
        }
      }
    };

    const initAllScriptObjects = scriptsCfg => handleAllScripts(scriptsCfg, initScriptObject, initAllScriptObjects);

    const initScriptMetrics = (objName, script) => {
      const scriptQueue = script.queue;
      if (scriptQueue) {
        window[objName][scriptQueue].push(() => {
          const scriptTiming = (timing[script.name || objName] ||= {});
          scriptTiming.apiReady = [getPerformanceNow()];
        });
      }
    };

    const initAllScriptMetrics = scriptsCfg => handleAllScripts(scriptsCfg, initScriptMetrics, initAllScriptMetrics);

    const loadScripts = scriptsCfg => {
      if (!scriptsCfg) return false;
      if (scriptsCfg.emitEvent) {
        window.dispatchEvent(new CustomEvent(scriptsCfg.emitEvent));
        adnginObj[scriptsCfg.emitEvent] = true;
        timing['loader'][scriptsCfg.emitEvent] = [getPerformanceNow()];
      }
      if (scriptsCfg.scripts) {
        scriptsCfg.scripts.forEach(script => {
          const scriptSettings = gcSettings[script.name] || {};

          const needsLoading = () => {
            const scriptObjectExists = !!window[scriptSettings.objName];
            return scriptSettings.load && (!scriptObjectExists || (scriptObjectExists && !script.skipLoadOnExists));
          };

          if (isArray(scriptSettings)) {
            scriptSettings.forEach(scriptEntry => {
              // Load the script if freq is missing or a random number between 0..99 is < freq. freq supports range from 0..100%
              if (scriptEntry.freq === undefined || mathFloor(Math.random() * 100) < scriptEntry.freq) {
                const objName = scriptEntry.name;
                const scriptData = script[objName] || {};
                const obj = initScriptObject(objName, scriptData);
                initScriptMetrics(objName, scriptData);
                const loadingTask = loadScriptHandler(scriptData, scriptEntry.name || scriptEntry.url, scriptEntry.url);
                if (obj) {
                  obj.loadingTask = loadingTask;
                }
              }
            });
          } else {
            if (needsLoading() && script.loadModule) {
              script.loadModule();
            }
            if (needsLoading() && scriptSettings.url) {
              const loadingTask = loadScriptObj(script);
              loadingTask.then(() => loadScripts(script.onLoad));
              const obj = window[scriptSettings.objName];
              if (obj) {
                obj.loadingTask = loadingTask;
              }
            } else {
              loadScripts(script.onLoad);
            }
          }
        });
      }
    };

    // Create global window objects and queues
    (window.adsbygoogle ||= []).pauseAdRequests = 1;
    window.snigelPubConf ||= {};
    initAllScriptObjects(scriptSetup);
    const adnginObj = window[gcSettings.adngin.objName];
    const timing = adnginObj.metrics.timing;

    // Initialize metrics objects for all scripts
    setPerformanceMetric('loader', entryName => /.*snigel.*loader.js$/i.test(entryName));
    initAllScriptMetrics(scriptSetup);

    // Check if consent wall is enabled
    if (globalConfig.settings && globalConfig.settings.adconsent && globalConfig.settings.adconsent.consentWall) {
      loadScriptHandler = loadScriptWithConsentWallCheck;
    } else {
      loadScriptHandler = loadScript;
    }

    // Load scripts
    const beforeLoadRaw = globalConfig.beforeLoad;
    if (beforeLoadRaw) {
      try {
        const beforeLoad = new Function(beforeLoadRaw);
        const result = beforeLoad();
        if (result && typeof result.then === 'function') {
          let timeoutId;
          const timeoutPromise = new Promise((_, reject) => {
            timeoutId = setTimeout(() => reject(new Error('beforeLoad: timed out after 5000ms')), 5000);
          });
          Promise.race([result, timeoutPromise]).then(
            () => {
              clearTimeout(timeoutId);
              loadScripts(scriptSetup);
            },
            e => {
              clearTimeout(timeoutId);
              console.error(e);
              loadScripts(scriptSetup);
            }
          );
        } else {
          loadScripts(scriptSetup);
        }
      } catch (e) {
        console.error(e);
        loadScripts(scriptSetup);
      }
    } else {
      loadScripts(scriptSetup);
    }
  })(globalConfig.version, globalConfig.site, globalConfig.settings, Math.floor, Array.isArray);
} catch (e) {
  if (globalConfig.passThroughException === true) {
    throw e;
  } else {
    console.error(e);
  }
}

/**
 * Represents a script object that can be embedded at different level of the script setup.
 *
 * @typedef {{
 *   name: string, // Name of the script, used as a key to get the settings in globalConfig.settings
 *   obj?: any, // Stub object immediately installed by the loader before the script is loaded
 *   queue?: string, // Command queue of the script, used by the metrics to measure when the script is started
 *   path: string, // path and query parameters that will be added to the url
 *   firstParty?: boolean // if the script a first party or third party script. We consider the snigel scripts being first party
 * }} Script
 */

/**
 * Handler function to load a script. It has 2 implementations: loadScript, loadScriptWithConsentWallCheck.
 *
 * @callback LoadScriptHandler
 * @param {Script} script the script setup
 * @param {string} name
 * @param {string} url
 * @returns {Promise} a promise that resolves when the script is loaded
 */
